import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import Images from "../../constant/images";
import Icon from "../Elements/Icon/Icon";
import "./Header.css";
import MenuIcon from "@mui/icons-material/Menu"; // Hamburger menu icon
import { useTranslation } from "react-i18next";
import { Divider, Drawer, IconButton, Typography } from "@mui/material";

const Header = () => {
  const location = useLocation();
  const [openDrawer, setOpenDrawer] = useState(false); // Drawer toggle state

  const { t, i18n } = useTranslation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    // Prevent 'rtl' class from being added, forcing LTR layout
    document.body.classList.remove("rtl");
    document.body.classList.add("ltr");
  };

  const navLinks = [
    { name: t("navigation.home"), path: "/" },
    { name: t("navigation.aboutUs"), path: "/about" },
    { name: t("navigation.service"), path: "/service" },
    { name: t("navigation.Applicant"), path: "/applicant" },
    { name: t("navigation.Employer"), path: "/employer" },
    { name: t("navigation.contactUs"), path: "/contact" },
    { name: t("navigation.HRSolution"), path: "/hr-solution" },
  ];
  const navLinks2 = [
    { name: "Support", path: "/" },
    { name: "Terms & Conditions", path: "/about" },
    { name: "Privacy Policy", path: "/service" },
  ];

  return (
    <AppBar
      color="inherit"
      className="header-main"
    >
      <Box
        display="flex"
        width="100%"
        justifyContent="space-between"
        alignItems="center"
      >
        {/* Logo */}
        <Box
          sx={{
            width: { xs: "20%", sm: "20%",md:"20%" },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Icon src={Images.logo} alt="Logo"  className="logo"/>
        </Box>
        <Box sx={{ display: { xs: "block", sm: "block",md:"none" } }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={() => setOpenDrawer(!openDrawer)}
          >
            <Icon src={Images.toggle} alt={""}></Icon>
          </IconButton>
        </Box>

        {/* Navigation Links */}
        <Box
          sx={{
            display: { xs: "none", sm: "none",md:"flex" },
            gap: "25px",
            marginLeft: "70px",
          }}
          width={"80%"}
        >
          {navLinks.map((link, index) => (
            <Button
              key={index}
              component={Link}
              to={link.path}
              className={`hader-links ${
                location.pathname === link.path ? "active" : ""
              }`}
            >
              {link.name}
            </Button>
          ))}

          {/* Language Selector */}
          {/* <Select
            value={i18n.language} // Ensure the selected language is reflected in the UI
            onChange={(event) => changeLanguage(event.target.value)} // Use onChange instead of onClick
            sx={{ border: 'none', color: '#000', fontWeight: 'bold', minWidth: '60px' }}
            variant="standard"
          >
            <MenuItem value="en">ENG</MenuItem>
            <MenuItem value="ar">عربي</MenuItem>
          </Select> */}
        </Box>
      </Box>
      {/* Drawer for Mobile Navigation */}
      <Drawer anchor="right" open={openDrawer}>
        <Box display={"flex"}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              padding: "20px",
              width: "245px",
              textAlign: "center",
              borderRadius: "40px 0px 40px 0px ",
              mt: 3,
            }}
          >
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`header-links ${
                  location.pathname === link.path ? "active" : ""
                }`}
                style={{
                  textDecoration: "none",
                  color: location.pathname === link.path ? "#741374" : "black",
                  fontWeight: "bold",
                }}
                onClick={() => setOpenDrawer(false)} // Close the drawer after selection
              >
                {link.name}
              </Link>
            ))}
            {/* Language Selector
          <Select
            value={i18n.language}
            onChange={(event) => changeLanguage(event.target.value)}
            sx={{
              border: 'none',
              color: '#000',
              fontWeight: 'bold',
              minWidth: '60px',
            }}
            variant="standard"
          >
            <MenuItem value="en">ENG</MenuItem>
          </Select> */}
            <Divider
              sx={{ border: "1px solid #741374", width: " 320px" }}
            ></Divider>
            {navLinks2.map((link, index) => (
              <Link
                key={index}
                to={link.path}
                className={`header-links ${
                  location.pathname === link.path ? "active" : ""
                }`}
                style={{
                  textDecoration: "none",
                  color: location.pathname === link.path ? "#741374" : "black",
                  fontWeight: "bold",
                }}
                onClick={() => setOpenDrawer(false)} // Close the drawer after selection
              >
                {link.name}
              </Link>
            ))}
            <Divider
              sx={{ border: "1px solid #741374", width: " 320px" }}
            ></Divider>{" "}
            <Box>
              <Typography
                className={`header-links `}
                onClick={() => setOpenDrawer(false)} // Close the drawer after selection
              >
                Address:
              </Typography>
              <Typography className="address-text">
                Headquarters Office: Bahrain <br />
                Office No: +973 770 222 00 <br />
                Mobile No.: +973 399 050 77 <br />
                +973 336 358 00 <br />
                Email: mailto:Info@almaalybh.com Instagram: @almaaly_manpowe
              </Typography>
            </Box>
          </Box>
          <Box mt={5} mr={3}>
            <IconButton>
              <Icon
                onClick={() => setOpenDrawer(false)}
                src={Images.toggleclose}
                alt={""}
              />
            </IconButton>
          </Box>
        </Box>
      </Drawer>
    </AppBar>
  );
};

export default Header;
